import _Tabs from './Tabs';
import _TabPanel from './TabPanel';

import './style';

export const Tabs = _Tabs;
export const TabPanel = _TabPanel;

export default Tabs;
